module.exports = __webpack_public_path__ + "img/achat.41433d9e.webp";